var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 15.7019C12.6508 15.5511 12.7432 15.3416 12.7429 15.1115L12.7429 15.0102C12.7429 14.5494 12.3699 14.1764 11.9097 14.177L7.35673 14.177L15.0585 6.47522C15.3838 6.14995 15.3838 5.62198 15.0585 5.29671C14.7332 4.97144 14.2052 4.97144 13.88 5.29671L6.17822 12.9985V8.44554C6.17822 7.98475 5.80519 7.61171 5.34498 7.6123H5.2437C4.7829 7.6123 4.40987 7.98534 4.41046 8.44554V15.1115C4.41046 15.5723 4.78349 15.9453 5.2437 15.9447L11.9097 15.9447C12.1401 15.9447 12.3493 15.8527 12.5001 15.7019Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.b932b1919468a7390b8c49074ae690fd.svg";
export { ForwardRef as ReactComponent };